// extracted by mini-css-extract-plugin
export default {"link":"bB-z","disabled":"cB-z"};